import * as React from "react";
import * as _ from "lodash";
import { PagerModel } from "./PagerModel";
import { Pager } from "./Pager";
import { ColumnType } from "./ColumnType";
import * as Big from "big.js";
import { formatDate } from "../util/date";
import { DeleteButtonModal } from "../util/DeleteButtonModal";
import { Link } from "react-router";
import * as moment from 'moment';

interface Props {
    pager?: PagerModel;
    columns?: Array<{ property: string, name: string, type?: ColumnType, getUrl?: (item: any) => string; }>;
    items?: Array<any>;
    dateEnabled?: boolean;
    date?: number;
    onDateChange: (date: number, pager: PagerModel) => void;
    onPagerChange: (pager: PagerModel) => void;
    loading?: boolean;
    onAction?: (item: any, actionId: string, index: number) => void;
    actions?: Array<DataTableAction>;
    removed?: number[];
    itemsUpdating: number[];
    showIndex?: boolean;

}

/**
 * Renderer for a column value. If the renderer is set on a column
 * it will be used to render it regardless of the property name.
 */
export interface Renderer<t> {
    (property: string, name: string, item: any): t
}

export enum ActionType {
    DEFAULT,
    LINK,
    CONFIRMATION,
}

export interface DataTableAction {
    id: string,
    name: string;
    className?: string;
    iconClassName?: string;
    filter?: (item: any) => boolean;
    disable?: (item: any) => boolean;
    type?: ActionType;
    getLink?: (item: any) => string;
}

export class DataTable extends React.Component<Props, {}> {

    types = ColumnType;
    limits: Array<number> = [10, 20, 50, 100];

    getClass(column) {
        if (this.hasSort(column)) {
            if (this.props.pager.orderBy == column.orderBy) {
                if (this.props.pager.ascending === true) {
                    return "sorting_asc";
                } else {
                    return "sorting_desc";
                }
            } else {
                return "sorting";
            }
        } else {
            return "";
        }
    }

    // getValue(item : any ,column : any) {
    //     return item[column.property]
    // }
    getPropertyValue(item: any, property: string, column: any): any {
        if (column.renderer != null) {
            return column.renderer(property, column.name, item);
        } else if (property.indexOf(".") != -1) {
            var parts = property.split(".");
            var value = item;

            for (var i = 0; i < parts.length; i++) {
                value = value[parts[i]];
            }
            return value;
        } else {
            return item[property];
        }

    }

    setOffset(offset: number) {
        var pager: PagerModel = _.clone(this.props.pager);
        pager.offset = offset;
        this.props.onPagerChange(pager);

    }

    hasSort(column: any) {
        return typeof (column.orderBy) != "undefined";
    }

    onAction(item: any, id: string, index: number) {
        if (this.props.itemsUpdating.indexOf(index) == -1) {
            this.props.onAction(item, id, index);
        }
    }

    sort(column: any) {
        var ascending = false;
        if (this.props.pager.orderBy == column.orderBy) {
            ascending = !this.props.pager.ascending;
        } else {
            ascending = this.props.pager.ascending;
        }

        var pager: PagerModel = Object.assign({}, this.props.pager);
        pager.orderBy = column.orderBy;
        pager.ascending = ascending;
        this.props.onPagerChange(pager);
    }

    getLimitOptions() {
        return this.limits.map(l => {
            return (
                <option key={'limit-' + l} value={"" + l}>{l}</option>
            );
        });
    }

    getHeaders() {
        return this.props.columns.map(c => {
            return (
                <th key={"h-" + c.name} onClick={this.sort.bind(this, c)} className={this.getClass(c)}>{c.name}</th>
            );
        })
    }

    getColumns(item: any) {
        return this.props.columns.map(c => {
            let cssName = c.property.replace(/\\./g, "_");
            if (c.type == ColumnType.BIG) {
                let val = new Big(this.getPropertyValue(item, c.property, c))
                let container = <span className={val.lt(0) ? "negative" : "positive"}>{val.toFixed(2)}</span>
                return <td className={cssName} key={c.property + "column"} style={{ textAlign: "right" }}>{container}</td>
            } else if (c.type == ColumnType.DATE) {
                return <td key={c.property + "column"}
                    className={cssName}>{formatDate(this.getPropertyValue(item, c.property, c))}</td>
            } else if (c.type == ColumnType.ENUM) {
                return <td key={c.property + "column"}
                    className={cssName + " " + this.getPropertyValue(item, c.property, c)}>{this.getPropertyValue(item, c.property, c)}</td>
            } else if (c.type == ColumnType.IMAGE) {
                return <td key={c.property + "column"} className={cssName}><img
                    src={this.getPropertyValue(item, c.property, c)} className="listViewImage" /></td>
            } else if (c.type === ColumnType.LINK && c.getUrl) {
                return (
                    <td key={c.property + "column"} className={cssName}>
                        <Link to={c.getUrl(item)}>{this.getPropertyValue(item, c.property, c)}</Link>
                    </td>
                );
            } else {
                return <td key={c.property + "column"}
                    className={cssName}>{this.getPropertyValue(item, c.property, c)}</td>
            }
        });
    }

    getActions(item: any, index: number): any {
        if (!this.props.actions || this.props.actions.length == 0 || this.isRemoved(index)) {
            return false;
        }
        return this.props.actions.filter(a => {
            if (a.filter && a.filter(item) === false) {
                return false;
            } else {
                return true;
            }
        }).map(a => {
            const key = "action" + a.id;
            if (a.type === ActionType.CONFIRMATION) {
                return <DeleteButtonModal iconClassName={a.iconClassName} className={a.className} key={key}
                    onDelete={this.onAction.bind(this, item, a.id, index)} label={a.name} />;
            } else if (a.type === ActionType.LINK) {
                return <Link key={key} className={a.className} to={a.getLink(item)}><i
                    className={a.iconClassName}></i> {a.name}</Link>
            } else {
                return (
                    <a
                        key={key}
                        onClick={this.onAction.bind(this, item, a.id, index)}
                        className={a.className}
                        disabled={a.disable && a.disable(item)}
                    >
                        <i className={a.iconClassName}></i> {a.name}
                    </a>
                );
            }

        });
    }

    isRemoved(index: number) {
        return this.props.removed && this.props.removed.length && this.props.removed.indexOf(index) != -1;
    }

    isUpdating(index: number) {
        return this.props.itemsUpdating && this.props.itemsUpdating.length && this.props.itemsUpdating.indexOf(index) != -1;
    }

    geActionColumn(index, item): any {
        if (this.props.actions && this.props.actions.length > 0) {
            return (
                <td className="actions">
                    {this.getActions(item, index)}
                </td>
            );
        }
        return false;
    }

    getRowClasses(index) {

        if (this.isRemoved(index)) {
            return "removed";
        }
        if (this.isUpdating(index)) {
            return "updating";
        }
        return "";
    }

    getResults() {

        return this.props.items.map((item, index) => {
            return (
                <tr key={index + "-" + item.id} className={this.getRowClasses(index)}>
                    {this.getIndexColumn(index)}
                    {this.getColumns(item)}
                    {this.geActionColumn(index, item)}
                </tr>
            )

        })
    }

    getContainerClass(): string {
        if (this.props.loading) {
            return "ibox-content loading";
        } else {
            return "ibox-content";
        }
    }

    limitChange(e: React.FormEvent) {
        var value: string = (e.target as any).value;
        var pager: PagerModel = Object.assign({}, this.props.pager);
        pager.limit = parseInt(value);
        pager.offset = 0;
        this.props.onPagerChange(pager);
    }

    dateChange(e: React.FormEvent) {
        const value: string = (e.target as any).value;
        const date = moment(value).valueOf();
        const pager: PagerModel = Object.assign({}, this.props.pager);
        pager.offset = 0;
        this.props.onDateChange(date, pager);
    }

    getIndexHeader(): any {
        if (this.props.showIndex) {
            return <th>Pos</th>
        }
        return false;
    }

    getActionHeader(): any {
        if (this.props.actions && this.props.actions.length > 0) {
            return <th className="actions">Actions</th>;
        }
        return false;
    }

    render() {
        return (
            <div className={this.getContainerClass()}>
                <div className="table-responsive">
                    <div className="dataTables_wrapper form-inline dt-bootstrap">
                        <div className="row">
                            <div className="col-sm-12">
                                <span className="nr-of-results">
                                    <span>Total Number of Results:</span> {this.props.pager.nrOfResults}
                                </span>
                                <div className="dataTables_length pull-right" id="editable_length">
                                    {this.props.dateEnabled == true &&
                                        <label>
                                            From Date{' '}
                                            <input type='date'
                                                value={this.props.date && moment(this.props.date).format('YYYY-MM-DD')}
                                                max={moment().format('YYYY-MM-DD')}
                                                onChange={this.dateChange.bind(this)}
                                            />
                                        </label>

                                    }
                                    {' '}
                                    <label>
                                        Show
                                        <select className="form-control input-sm"
                                            value={"" + this.props.pager.limit}
                                            onChange={this.limitChange.bind(this)}>
                                            {this.getLimitOptions()}
                                        </select>
                                    </label>

                                </div>
                            </div>
                        </div>
                        <table className="table table-striped table-bordered table-hover dataTables-example dataTable">
                            <thead>
                                <tr role="row">
                                    {this.getIndexHeader()}
                                    {this.getHeaders()}
                                    {this.getActionHeader()}
                                </tr>
                            </thead>
                            <tbody>
                                {this.getResults()}
                            </tbody>
                        </table>
                        <Pager onOffsetUpdate={this.setOffset.bind(this)} model={this.props.pager} />
                    </div>
                </div>
            </div>
        );
    }


    getIndexColumn(index: number): any {
        if (this.props.showIndex) {
            return <td>{index + 1 + (this.props.pager.offset ? this.props.pager.offset : 0)}</td>
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/list/DataTable.tsx